export class AnimatedSprite {
  constructor({
    image,
    frameWidth,
    frameHeight,
    frameCount,
    frameSpeed
  }) {
    this.image = image;
    this.frameWidth = frameWidth;
    this.frameHeight = frameHeight;
    this.frameCount = frameCount;
    this.frameSpeed = frameSpeed;

    this.frameIndex = 0;
    this.frameTimer = 0;
  }

  update() {
    this.frameTimer++;
    if (this.frameTimer >= this.frameSpeed) {
      this.frameIndex = (this.frameIndex + 1) % this.frameCount;
      this.frameTimer = 0;
    }
  }

  draw(ctx, x, y, w, h) {
    if (this.image) {
      ctx.drawImage(
        this.image,
        this.frameIndex * this.frameWidth,
        0,
        this.frameWidth,
        this.frameHeight,
        x,
        y,
        w,
        h
      );
    }
  }
}

